import * as React from "react"
import Svg, { Path } from "react-native-svg"
const SvgComponent = (props) => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={18}
        height={16}
        fill="none"
        {...props}
    >
        <Path
            fill="#3B3B3B"
            d="M5.5 9.281c0 .281-.125.531-.313.719l-1.375 1.344c-.093.125-.093.281 0 .375l1.97 1.969c.093.093.25.093.374 0L7.5 12.312a.99.99 0 0 1 .719-.28h1.5a.534.534 0 0 0 .406-.22l.594-.843L6.53 6.78l-.843.594a.504.504 0 0 0-.188.406v1.5Zm10.844-6.156a.658.658 0 0 0 .156-.406.738.738 0 0 0-.219-.5l-1-1a.737.737 0 0 0-.5-.219.658.658 0 0 0-.406.156l-7 5.032 3.938 3.937 5.03-7ZM8.219 13l-1.375 1.375a1.16 1.16 0 0 1-1.313.281l-1.125 1.125c-.125.156-.312.219-.531.219H.75a.722.722 0 0 1-.75-.75v-.125c0-.219.063-.406.219-.531l2.625-2.625a1.161 1.161 0 0 1 .281-1.313L4.5 9.281v-1.5c0-.468.219-.937.625-1.218l8.656-6.22c.313-.218.656-.343 1-.343.438 0 .875.188 1.188.5L17 1.531c.313.313.5.75.5 1.188 0 .344-.125.687-.344 1l-6.218 8.656c-.282.406-.75.625-1.22.625h-1.5ZM4.75 14.031 3.469 12.75 1.188 15H3.78l.969-.969Z"
        />
    </Svg>
)
export default SvgComponent
